import React, { FC, ReactElement } from 'react'
import { ExternalComponent } from '../ExternalComponent/Main/ExternalComponent'
import { useCXScore } from './useCXScore'
import { MountOptionsOverrides } from './Types'

/**
 * This component is responsible for rendering the CX Score external component and providing it with the necessary authentication token and error handling callbacks.
 */
export const CXScore: FC = (): ReactElement => {
    const mountOptionsOverrides: MountOptionsOverrides = useCXScore()

    return <ExternalComponent componentKey='cxScore' mountOptionsOverrides={mountOptionsOverrides} />
}
